import React from "react";
import ListView from "../listviews/ListView";
import TextField2 from "../textfields/TextField2";
import Space from "../layout/Space";
import Divider from "../layout/Divider";

import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import SecondaryButton from "../buttons/SecondaryButton";

function MemberManager({
  orgData,
  title,
  users,
  removable,
  none_text = "Aucun membre",
  handleAdd,
  email_value = "",
  setEmailValue,
  role = "",
  setRole,
  display_name,
  setDisplayName,
  show_id = false,
}) {
  return (
    <div className="w-full">
      <div className="text-h1 font-semibold text-pr ">{title}</div>
      <Divider orientation="horizontal" />
      <Space y={10} />
      <div className="flex flex-col gap-1 max-w-c500">
        <TextField2
          label="Email"
          value={email_value}
          onChange={(e) => setEmailValue(e.target.value)}
        ></TextField2>
        <TextField2
          label="Prénom Nom"
          value={display_name}
          onChange={(e) => setDisplayName(e.target.value)}
        ></TextField2>
        <DropDownGPT03
          label="Type d'utilisateur"
          value={role}
          onChange={(value) => {
            setRole(value);
          }}
          sx={{ width: "495px" }}
          items={memberRoles}
        />

        <Space x={0} />
        <div className="flex flex-row justify-end">
          <SecondaryButton
            className="w-fit"
            disabled={email_value === "" || role === ""}
            onClick={handleAdd}
          >
            Inviter
          </SecondaryButton>
        </div>
      </div>
      <Space y={10} />
      <div className="w-full">
        <ListView
          users={users}
          removable={removable}
          show_id={show_id}
        ></ListView>
        {users.length === 0 && (
          <>
            <div className="flex flex-row gap-3 bg-neutral-200 rounded-xl px-2 py-1 w-fit">
              <div className="text-h3 font-semibold text-shadow_50">
                {none_text}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MemberManager;

export const memberRoles = [
  { value: "operator", label: "Technicien" },
  {
    value: "secretary",
    label: "Assistant(e) technique",
  },
  { value: "commercial", label: "Commercial" },
  { value: "comptable", label: "Comptable" },

  { value: "owner", label: "Gérant (pas opérationnel)" },

  { value: "respo", label: "Responsable" },
  {
    value: "conductor",
    label: "Conducteur de travaux",
  },

  {
    value: "drawer",
    label: "Dessinateur-Métreur",
  },
  {
    value: "project_manager",
    label: "Chargé de projet",
  },
  {
    value: "architect",
    label: "Architecte",
  },
];
